/* ==========================================================================
   Pronto — theme behaviour
   Vanilla JS, no dependencies. Everything degrades to a working page if JS
   fails: filters and pagination are real links, the cart is a real form.
   ========================================================================== */

(function () {
  'use strict';

  var PRONTO = window.PRONTO || {};
  var routes = PRONTO.routes || {};

  /* ---------------------------------------------------------------- helpers */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function announce(message) {
    var region = $('[data-live-region]');
    if (region) region.textContent = message;
  }

  function formatMoney(cents) {
    // Server-rendered money is preferred everywhere; this is only a fallback.
    var format = PRONTO.moneyFormat || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  function trapFocus(container) {
    var focusables = $$(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!focusables.length) return function () {};

    function onKey(e) {
      if (e.key !== 'Tab') return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKey);
    focusables[0].focus();
    return function () {
      container.removeEventListener('keydown', onKey);
    };
  }

  /* --------------------------------------------------------- reveal on scroll */

  function initReveal() {
    var items = $$('.reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* -------------------------------------------------------------- back to top */

  function initBackToTop() {
    var floatBtn = $('.back-to-top-float');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-back-to-top]');
      if (!trigger) return;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    if (!floatBtn) return;

    function toggle() {
      floatBtn.classList.toggle('is-visible', window.scrollY > 600);
    }

    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  /* ------------------------------------------------------------ sticky header */

  function initStickyHeader() {
    var header = $('[data-site-header]');
    if (!header || header.dataset.overlay !== 'true') return;

    function onScroll() {
      header.classList.toggle('is-stuck', window.scrollY > 80);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------- mobile nav */

  function initMobileNav() {
    var nav = $('#MobileNav');
    if (!nav) return;
    var release = null;

    function open() {
      nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      release = trapFocus(nav);
      $$('[data-mobile-nav-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }

    function close() {
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
      if (release) release();
      $$('[data-mobile-nav-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mobile-nav-open]')) {
        e.preventDefault();
        open();
      } else if (e.target.closest('[data-mobile-nav-close]')) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });
  }

  /* -------------------------------------------------------- announcement bar */

  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.items = $$('[data-announcement]', this);
      if (this.items.length < 2) return;
      this.index = 0;
      var interval = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = setInterval(this.next.bind(this), interval);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    next() {
      this.items[this.index].hidden = true;
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].hidden = false;
    }
  }

  if (!customElements.get('announcement-rotator')) {
    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  /* -------------------------------------------------------- locale switcher */

  function initLocaleForms() {
    $$('[data-locale-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* --------------------------------------------------------- hero slideshow */

  class SlideshowHero extends HTMLElement {
    connectedCallback() {
      this.slides = $$('[data-hero-slide]', this);
      if (this.slides.length < 2) return;

      this.section = this.closest('.hero') || this.parentElement;
      this.dots = $$('[data-hero-dot]', this.section);
      this.index = 0;

      this.onPrev = this.go.bind(this, -1);
      this.onNext = this.go.bind(this, 1);

      var prev = $('[data-hero-prev]', this.section);
      var next = $('[data-hero-next]', this.section);
      if (prev) prev.addEventListener('click', this.onPrev);
      if (next) next.addEventListener('click', this.onNext);

      this.dots.forEach(
        function (dot) {
          dot.addEventListener(
            'click',
            function () {
              this.show(parseInt(dot.dataset.heroDot, 10));
              this.restart();
            }.bind(this)
          );
        }.bind(this)
      );

      this.bindSwipe();

      if (this.dataset.autoplay === 'true') this.start();

      this.addEventListener('mouseenter', this.stop.bind(this));
      this.addEventListener('mouseleave', this.start.bind(this));
    }

    disconnectedCallback() {
      this.stop();
    }

    bindSwipe() {
      var startX = null;
      this.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );
      this.addEventListener(
        'touchend',
        function (e) {
          if (startX === null) return;
          var delta = e.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 40) {
            this.go(delta < 0 ? 1 : -1);
            this.restart();
          }
          startX = null;
        }.bind(this)
      );
    }

    start() {
      if (this.dataset.autoplay !== 'true' || this.timer) return;
      var interval = parseInt(this.dataset.interval, 10) || 6000;
      this.timer = setInterval(this.go.bind(this, 1), interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    go(step) {
      this.show((this.index + step + this.slides.length) % this.slides.length);
    }

    show(i) {
      this.slides[this.index].classList.remove('is-active');
      if (this.dots[this.index]) {
        this.dots[this.index].classList.remove('is-active');
        this.dots[this.index].setAttribute('aria-selected', 'false');
      }
      this.index = i;
      this.slides[i].classList.add('is-active');
      if (this.dots[i]) {
        this.dots[i].classList.add('is-active');
        this.dots[i].setAttribute('aria-selected', 'true');
      }
    }
  }

  if (!customElements.get('slideshow-hero')) {
    customElements.define('slideshow-hero', SlideshowHero);
  }

  /* ------------------------------------------------------------- accordions */

  function initAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;

      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      var icon = $('.accordion__icon', trigger);

      trigger.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
      if (icon) icon.textContent = expanded ? '+' : '−';
    });
  }

  /* --------------------------------------------------------- video sound */

  function initVideoSound() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sound-toggle]');
      if (!btn) return;

      var card = btn.closest('.video-card');
      var video = card && $('[data-shop-video]', card);
      if (!video) return;

      var turningOn = video.muted;

      // Only one clip plays with sound at a time.
      $$('[data-shop-video]').forEach(function (v) {
        if (v !== video) {
          v.muted = true;
          var otherBtn = v.closest('.video-card') && $('[data-sound-toggle]', v.closest('.video-card'));
          if (otherBtn) otherBtn.setAttribute('aria-pressed', 'false');
        }
      });

      video.muted = !turningOn;
      btn.setAttribute('aria-pressed', String(turningOn));

      var on = btn.querySelector('svg');
      if (on) {
        on.innerHTML = turningOn
          ? '<path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M16 9a4 4 0 0 1 0 6"/>'
          : '<path d="M11 5 6 9H3v6h3l5 4V5z"/><line x1="16" y1="9" x2="21" y2="15"/><line x1="21" y1="9" x2="16" y2="15"/>';
      }
    });
  }

  /* ------------------------------------------------------------- wishlist */

  var WISHLIST_KEY = 'pronto:wishlist';

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (err) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (err) {
      /* storage unavailable — the button still toggles for this page view */
    }
  }

  function initWishlist() {
    function paint() {
      var list = readWishlist();
      $$('[data-wishlist-toggle]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(list.indexOf(btn.dataset.handle) !== -1));
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();

      var list = readWishlist();
      var handle = btn.dataset.handle;
      var at = list.indexOf(handle);

      if (at === -1) {
        list.push(handle);
        announce(PRONTO.strings ? PRONTO.strings.wishlistAdd : 'Added to wishlist');
      } else {
        list.splice(at, 1);
        announce(PRONTO.strings ? PRONTO.strings.wishlistRemove : 'Removed from wishlist');
      }

      writeWishlist(list);
      paint();
    });

    paint();
    document.addEventListener('pronto:section:updated', paint);
  }

  /* ----------------------------------------------------------------- cart */

  function getCartDrawer() {
    return $('[data-cart-drawer]');
  }

  var releaseCartFocus = null;

  // Free-delivery bar: grow the fill from `from` (percent) to its target.
  function growShipBar(root, from) {
    var fill = root && root.querySelector('[data-ship-fill]');
    if (!fill) return;
    var target = fill.dataset.pct;
    fill.style.transition = 'none';
    fill.style.width = (from || 0) + '%';
    void fill.offsetWidth;
    fill.style.transition = '';
    fill.style.width = target + '%';
  }

  function openCart() {
    var drawer = getCartDrawer();
    if (!drawer) return;
    if (!drawer.classList.contains('is-open')) {
      setTimeout(function () { growShipBar(drawer, 0); }, 200);
    }
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    releaseCartFocus = trapFocus(drawer);
  }

  function closeCart() {
    var drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    if (releaseCartFocus) releaseCartFocus();
  }

  function refreshCartCount() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function refreshCartDrawer(sectionsHtml) {
    var drawer = getCartDrawer();
    if (!drawer) return Promise.resolve();

    function swap(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('[data-cart-drawer]');
      if (!fresh) return;
      var wasOpen = drawer.classList.contains('is-open');
      var oldFill = drawer.querySelector('[data-ship-fill]');
      var oldPct = oldFill ? oldFill.dataset.pct : 0;
      drawer.innerHTML = fresh.innerHTML;
      if (wasOpen) drawer.classList.add('is-open');
      growShipBar(drawer, oldPct);
      document.dispatchEvent(new CustomEvent('pronto:section:updated'));
    }

    if (sectionsHtml && sectionsHtml['cart-drawer']) {
      swap(sectionsHtml['cart-drawer']);
      return Promise.resolve();
    }

    return fetch(routes.root + '?sections=cart-drawer')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data['cart-drawer']) swap(data['cart-drawer']);
      })
      .catch(function () {});
  }

  function addToCart(formData, onDone, onError) {
    formData.append('sections', 'cart-drawer');

    fetch(routes.cart_add, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          if (onError) onError(result.data.description || result.data.message);
          return;
        }
        return Promise.all([refreshCartDrawer(result.data.sections), refreshCartCount()]).then(function () {
          if (PRONTO.cartType === 'drawer') openCart();
          announce(PRONTO.strings ? PRONTO.strings.added : 'Added to bag');
          if (onDone) onDone();
        });
      })
      .catch(function () {
        if (onError) onError();
      });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (window.location.pathname.indexOf('/cart') !== -1) {
          window.location.reload();
          return;
        }
        return Promise.all([refreshCartDrawer(data.sections), refreshCartCount()]);
      })
      .catch(function () {});
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cart-open]');
      if (open && PRONTO.cartType === 'drawer' && getCartDrawer()) {
        e.preventDefault();
        openCart();
        return;
      }

      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeCart();
        return;
      }

      var step = e.target.closest('[data-qty-change]');
      if (step) {
        e.preventDefault();
        var input = $('[data-qty-input][data-line-key="' + step.dataset.lineKey + '"]');
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.qtyChange, 10));
        input.value = next;
        changeLine(step.dataset.lineKey, next);
        return;
      }

      var remove = e.target.closest('[data-line-remove]');
      if (remove) {
        e.preventDefault();
        changeLine(remove.dataset.lineKey, 0);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      changeLine(input.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
    });

    document.addEventListener('keydown', function (e) {
      var drawer = getCartDrawer();
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
    });

    // Order note, debounced
    var noteTimer;
    document.addEventListener('input', function (e) {
      var note = e.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch(routes.cart_update, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {});
      }, 600);
    });
  }

  /* ------------------------------------------------------------- quick add */

  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-quick-add-form]');
      if (!form) return;
      e.preventDefault();

      var btn = $('button', form);
      if (btn) btn.classList.add('is-loading');

      addToCart(
        new FormData(form),
        function () {
          if (btn) btn.classList.remove('is-loading');
        },
        function () {
          if (btn) btn.classList.remove('is-loading');
          form.submit();
        }
      );
    });
  }

  /* ------------------------------------------------------- pay-online offer */

  // "Pay online & save" choice in the cart (snippets/prepay-offer.liquid).
  // The discount itself is the code; the cart attribute only tells the
  // payment-rules app to hide Cash on Delivery at checkout. Keep this key and
  // its "online" value in sync with that app's rule.
  var PREPAY_KEY = 'payment_preference';
  var PREPAY_FLASH_KEY = 'pronto:prepay:flash';
  var PREPAY_RETRY_KEY = 'pronto:prepay:retry';
  var prepayReconciled = false;
  var prepayFlash = (function () {
    try {
      var message = sessionStorage.getItem(PREPAY_FLASH_KEY);
      sessionStorage.removeItem(PREPAY_FLASH_KEY);
      return message;
    } catch (e) {
      return null;
    }
  })();

  function getCartJson() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function postCartUpdate(body) {
    return fetch(routes.cart_update, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  // Every code on the cart, so switching the offer never drops a code the
  // shopper entered themselves (/cart/update.js replaces the whole list).
  function cartCodes(cart) {
    var seen = {};
    var list = [];
    function add(code) {
      if (!code) return;
      var k = String(code).toLowerCase();
      if (seen[k]) return;
      seen[k] = true;
      list.push(String(code));
    }
    (cart.discount_codes || []).forEach(function (d) {
      add(d.code);
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.type === 'discount_code') add(d.title);
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.type === 'discount_code') {
          add(a.discount_application.title);
        }
      });
    });
    return list;
  }

  function codeIsApplied(cart, code) {
    var c = code.toLowerCase();
    var listed = (cart.discount_codes || []).filter(function (d) {
      return String(d.code || '').toLowerCase() === c;
    })[0];
    if (listed) return listed.applicable !== false;
    return (cart.cart_level_discount_applications || []).some(function (d) {
      return d.type === 'discount_code' && String(d.title || '').toLowerCase() === c;
    });
  }

  function onCartPage() {
    return window.location.pathname.indexOf('/cart') !== -1;
  }

  class PrepayOffer extends HTMLElement {
    connectedCallback() {
      this.code = this.dataset.code || '';
      this.statusEl = $('[data-prepay-status]', this);
      this.busy = false;
      this.onChange = this.onChange.bind(this);
      this.addEventListener('change', this.onChange);

      if (prepayFlash) {
        this.say(prepayFlash);
        setTimeout(function () {
          prepayFlash = null;
        }, 0);
      }

      if (this.dataset.eligible === 'false') {
        // No White Friday shoe in the cart: the 10% does not apply, so take a
        // leftover code off and keep whatever payment choice was made
        if (this.code && this.dataset.applied === 'true') {
          this.select(this.dataset.attr === 'online' ? 'online' : 'cod', true);
        }
        return;
      }

      this.reconcile();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    say(message) {
      if (this.statusEl) this.statusEl.textContent = message || '';
    }

    resetRadios() {
      var state = this.dataset.state;
      $$('[data-prepay-choice]', this).forEach(function (input) {
        input.checked = input.value === state;
      });
    }

    onChange(e) {
      var input = e.target.closest('[data-prepay-choice]');
      if (!input || !input.checked) return;
      if (this.busy) {
        this.resetRadios();
        return;
      }
      this.select(input.value, false);
    }

    // Bring the attribute and the code back in line if they drifted apart,
    // e.g. the code was removed at checkout or applied through a /discount link.
    reconcile() {
      if (prepayReconciled || !this.code) return;
      var attr = this.dataset.attr;
      var applied = this.dataset.applied === 'true';

      if (attr === 'online' && !applied) {
        prepayReconciled = true;
        // Once per minute at most, so a code Shopify accepts but never shows
        // as applied can't keep reloading the cart page.
        var last = 0;
        try {
          last = parseInt(sessionStorage.getItem(PREPAY_RETRY_KEY), 10) || 0;
          sessionStorage.setItem(PREPAY_RETRY_KEY, String(Date.now()));
        } catch (e) {}
        if (Date.now() - last < 60000) return;
        this.select('online', true);
      } else if (applied && attr !== 'online') {
        prepayReconciled = true;
        var attributes = {};
        attributes[PREPAY_KEY] = 'online';
        postCartUpdate({ attributes: attributes })
          .then(function () {
            $$('prepay-offer').forEach(function (el) {
              el.dataset.attr = 'online';
            });
          })
          .catch(function () {});
      }
    }

    select(choice, quiet) {
      var self = this;
      var code = this.code;
      var plain = this.dataset.eligible === 'false';
      var others = [];
      var attributes = {};

      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.classList.add('is-loading');
      if (!quiet) this.say(this.dataset.msgUpdating);

      getCartJson()
        .then(function (cart) {
          others = cartCodes(cart).filter(function (c) {
            return c.toLowerCase() !== code.toLowerCase();
          });
          attributes[PREPAY_KEY] = choice === 'online' ? 'online' : 'cod';
          var codes = choice === 'online' && !plain ? others.concat(code) : others;
          return postCartUpdate({ attributes: attributes, discount: codes.join(',') });
        })
        .then(function (cart) {
          if (choice !== 'online') return self.dataset.msgCod;
          if (plain) return self.dataset.msgOnline;
          if (codeIsApplied(cart, code)) return self.dataset.msgOnline;

          // The code didn't apply (expired, minimum not met, can't combine).
          // Undo the whole choice so the shopper isn't left with COD hidden
          // and no discount.
          var undo = {};
          undo[PREPAY_KEY] = 'cod';
          return postCartUpdate({ attributes: undo, discount: others.join(',') }).then(function () {
            return self.dataset.msgNotApplicable;
          });
        })
        .then(function (message) {
          self.finish(choice, message);
        })
        .catch(function () {
          self.busy = false;
          self.removeAttribute('aria-busy');
          self.classList.remove('is-loading');
          self.resetRadios();
          self.say(self.dataset.msgError);
        });
    }

    finish(choice, message) {
      if (onCartPage()) {
        try {
          sessionStorage.setItem(PREPAY_FLASH_KEY, message);
        } catch (e) {}
        window.location.reload();
        return;
      }

      prepayFlash = message;
      Promise.all([refreshCartDrawer(), refreshCartCount()]).then(function () {
        prepayFlash = null;
        announce(message);
        // The drawer markup was replaced; put focus back on the chosen option.
        var again =
          $('[data-cart-drawer] prepay-offer [data-prepay-choice]:checked') ||
          $('[data-cart-drawer] prepay-offer [data-prepay-choice][value="' + choice + '"]');
        if (again) again.focus();
      });
    }
  }

  if (!customElements.get('prepay-offer')) {
    customElements.define('prepay-offer', PrepayOffer);
  }

  // Checkout guard for pay-online carts. Whatever happened to the code since
  // it was chosen (another code typed over it, a cart reload, a /discount
  // link), it is put back on the cart and also handed to checkout in the URL,
  // so the shopper always lands on checkout with the online discount on.
  // Checkout itself is Shopify's; a shopper can still remove it there.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      var trigger = e.submitter;
      var isCheckout =
        (trigger && trigger.name === 'checkout') ||
        (!trigger && form.querySelector && form.querySelector('[name="checkout"]'));
      var code = (PRONTO.prepayCode || '').trim();
      if (!isCheckout || !code || form.dataset.prepayChecked === 'true') return;

      e.preventDefault();
      var go = function (withCode) {
        // Shopify's own /discount link applies the code, then redirects to checkout
        window.location.href = withCode
          ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout')
          : '/checkout';
      };

      // Saves any quantity edits in the form first, as a normal checkout submit would
      var pending = form.matches('form[action*="/cart"]') && form.querySelector('[name^="updates"]')
        ? fetch(routes.cart_update, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        : Promise.resolve();

      pending
        .then(getCartJson)
        .then(function (cart) {
          var pref = String((cart.attributes || {})[PREPAY_KEY] || '').toLowerCase();
          if (pref !== 'online') return go(false);
          // Cart has no White Friday shoe, so it does not get the 10%
          if (document.querySelector('prepay-offer[data-eligible="false"]')) return go(false);
          if (codeIsApplied(cart, code)) return go(true);
          // The online code does not combine with others, so it goes on alone
          return postCartUpdate({ discount: code }).then(function (updated) {
            go(codeIsApplied(updated, code));
          });
        })
        .catch(function () {
          // Never block a purchase: fall back to the ordinary checkout submit
          form.dataset.prepayChecked = 'true';
          if (trigger && trigger.name) {
            var keep = document.createElement('input');
            keep.type = 'hidden';
            keep.name = trigger.name;
            keep.value = trigger.value || '';
            form.appendChild(keep);
          }
          form.submit();
        });
    },
    true
  );

  /* ------------------------------------------------------------- quick shop */

  class QuickShop extends HTMLElement {
    connectedCallback() {
      var script = $('[data-qs-variants]', this);
      if (!script) return;

      try {
        this.variants = JSON.parse(script.textContent);
      } catch (err) {
        return;
      }

      this.optionCount = this.variants.length ? this.variants[0].options.length : 0;
      this.selection = new Array(this.optionCount).fill(null);

      this.priceEl = $('[data-qs-price]', this);
      this.compareEl = $('[data-qs-compare]', this);
      this.messageEl = $('[data-qs-message]', this);
      this.addBtn = $('[data-qs-add]', this);

      // Preselect from the first sellable variant so one tap can be enough.
      var first = this.variants.find(function (v) {
        return v.available;
      });
      if (first) {
        first.options.forEach(
          function (value, i) {
            if ($$('[data-qs-option][data-position="' + (i + 1) + '"]', this).length) {
              this.selection[i] = value;
            }
          }.bind(this)
        );
      }

      this.addEventListener('click', this.onClick.bind(this));
      this.paint();
    }

    onClick(e) {
      var opt = e.target.closest('[data-qs-option]');
      if (opt) {
        e.preventDefault();
        var index = parseInt(opt.dataset.position, 10) - 1;
        this.selection[index] = opt.dataset.value;
        // A colour that does not come in the chosen size moves the other
        // choices to the first combination that is in stock, instead of
        // leaving an impossible pair selected.
        if (!this.match() || !this.match().available) this.settleOn(index, opt.dataset.value);
        // Whichever option holds the colour, show the photo for the colour now chosen
        var colourBtn = $('.swatch--button[data-qs-option]', this);
        if (colourBtn) {
          var ci = parseInt(colourBtn.dataset.position, 10) - 1;
          if (this.selection[ci] !== null) this.showPhoto(ci, this.selection[ci]);
        }
        this.hideMessage();
        this.paint();
        return;
      }

      if (e.target.closest('[data-qs-add]')) {
        e.preventDefault();
        this.add();
      }
    }

    settleOn(index, value) {
      var sel = this.selection;
      var best = this.variants.find(function (v) { return v.available && v.options[index] === value; });
      if (!best) return;
      best.options.forEach(function (other, i) {
        if (i !== index && sel[i] !== null) sel[i] = other;
      });
    }

    /* Shows the photo of the first variant in the picked colour */
    showPhoto(index, value) {
      var withImage = this.variants.find(function (v) { return v.options[index] === value && v.image; });
      var img = $('.card__img-primary', this);
      if (!withImage || !img) return;
      if (img.getAttribute('src') === withImage.image) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = withImage.image;
      this.classList.add('has-variant-photo');
    }

    match() {
      var sel = this.selection;
      return this.variants.find(function (v) {
        return v.options.every(function (value, i) {
          return sel[i] === null || sel[i] === value;
        });
      });
    }

    /* A value is offered if some sellable variant carries it alongside the
       other choices already made. */
    isReachable(index, value) {
      var sel = this.selection;
      return this.variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[index] !== value) return false;
        return v.options.every(function (other, i) {
          return i === index || sel[i] === null || sel[i] === other;
        });
      });
    }

    paint() {
      $$('[data-qs-option]', this).forEach(
        function (btn) {
          var index = parseInt(btn.dataset.position, 10) - 1;
          var isSelected = this.selection[index] === btn.dataset.value;
          btn.classList.toggle('is-selected', isSelected);
          btn.setAttribute('aria-checked', String(isSelected));
          btn.classList.toggle('is-unavailable', !this.isReachable(index, btn.dataset.value));
        }.bind(this)
      );

      var variant = this.match();
      var cardPrice = $('[data-cp-price]', this);
      if (variant && cardPrice && variant.card_price) {
        cardPrice.textContent = variant.card_price;
        var from = $('[data-cp-from]', this);
        if (from) from.hidden = true;
      }
      if (variant && this.priceEl) {
        this.priceEl.textContent = variant.price;
        if (this.compareEl) {
          this.compareEl.textContent = variant.on_sale ? variant.compare_at_price : '';
          this.compareEl.hidden = !variant.on_sale;
        }
      }
    }

    showMessage(text) {
      if (!this.messageEl) return;
      this.messageEl.textContent = text;
      this.messageEl.hidden = false;
    }

    hideMessage() {
      if (this.messageEl) this.messageEl.hidden = true;
    }

    add() {
      var missing = this.selection.indexOf(null);
      if (missing !== -1) {
        this.showMessage((PRONTO.strings && PRONTO.strings.chooseOptions) || 'Choose an option first');
        return;
      }

      var variant = this.match();

      if (!variant) {
        this.showMessage((PRONTO.strings && PRONTO.strings.unavailable) || 'Unavailable');
        return;
      }

      if (!variant.available) {
        this.showMessage((PRONTO.strings && PRONTO.strings.soldOut) || 'Sold out');
        return;
      }

      var data = new FormData();
      data.append('id', variant.id);
      data.append('quantity', 1);

      if (this.addBtn) this.addBtn.classList.add('is-loading');

      addToCart(
        data,
        function () {
          if (this.addBtn) this.addBtn.classList.remove('is-loading');
        }.bind(this),
        function (message) {
          if (this.addBtn) this.addBtn.classList.remove('is-loading');
          this.showMessage(message || 'Could not add that to the bag.');
        }.bind(this)
      );
    }
  }

  if (!customElements.get('quick-shop')) {
    customElements.define('quick-shop', QuickShop);
  }

  /* --------------------------------------------------------- variant picker */

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      var script = $('[data-variant-data]', this);
      if (!script) return;

      try {
        this.variants = JSON.parse(script.textContent);
      } catch (err) {
        return;
      }

      this.root = this.closest('product-form-root') || document;
      this.addEventListener('click', this.onSelect.bind(this));
      this.syncAvailability();
    }

    get selectedOptions() {
      return $$('[data-option-select].is-active', this)
        .sort(function (a, b) {
          return a.dataset.optionPosition - b.dataset.optionPosition;
        })
        .map(function (btn) {
          return btn.dataset.optionValue;
        });
    }

    onSelect(e) {
      var btn = e.target.closest('[data-option-select]');
      if (!btn || btn.classList.contains('is-active')) return;

      var group = btn.parentElement;
      $$('[data-option-select]', group).forEach(function (other) {
        other.classList.remove('is-active');
        other.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked', 'true');

      var block = btn.closest('.option-block');
      var label = block && $('[data-option-value]', block);
      if (label) label.textContent = btn.dataset.optionValue;

      var gallery = $('.product-gallery[data-colour-filter]', this.root);
      if (gallery) filterGalleryByColour(gallery, this.selectedOptions);

      this.update();
      this.syncAvailability();
    }

    findVariant() {
      var selected = this.selectedOptions;
      return this.variants.find(function (variant) {
        return variant.options.every(function (option, i) {
          return option === selected[i];
        });
      });
    }

    update() {
      var variant = this.findVariant();
      var idField = $('[data-variant-id]', this.root);
      var addBtn = $('[data-add-button]', this.root);
      var addLabel = $('[data-add-label]', this.root);
      var priceEl = $('[data-price]', this.root);
      var compareEl = $('[data-compare-price]', this.root);
      var strings = PRONTO.strings || {};

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = strings.unavailable || 'Unavailable';
        if (idField) idField.disabled = true;
        return;
      }

      if (idField) {
        idField.value = variant.id;
        idField.disabled = !variant.available;
      }

      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) {
        addLabel.textContent = variant.available
          ? strings.addToBag || 'Add to Bag'
          : strings.soldOut || 'Sold out';
      }

      if (priceEl) priceEl.textContent = variant.price_formatted || formatMoney(variant.price);

      // Notify me shows only while the selected variant is sold out
      var notify = $('[data-notify-me]', this.root);
      if (notify) {
        notify.hidden = !!variant.available;
        var nVariant = $('[data-notify-variant]', notify);
        var nSku = $('[data-notify-sku]', notify);
        var nLink = $('[data-notify-link]', notify);
        if (nVariant) nVariant.value = (variant.options || []).join(' / ');
        if (nSku) nSku.value = variant.sku || '';
        if (nLink) nLink.value = nLink.dataset.base + '?variant=' + variant.id;
      }

      // Card payment offer: the discounted price follows the selected variant
      $$('[data-card-offer]', this.root).forEach(function (offer) {
        var out = $('[data-card-offer-price]', offer);
        var pct = parseFloat(offer.dataset.percent) || 0;
        if (out) out.textContent = formatMoney(Math.round((variant.price * (100 - pct)) / 100));
      });

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_at_price_formatted || formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      // Bundle row for the current product follows the selection
      var bundlePrice = $('[data-bundle-price]', this.root);
      var bundleInput = $('[data-bundle-item][data-current-product]', this.root);
      if (bundlePrice) bundlePrice.textContent = variant.price_formatted || formatMoney(variant.price);
      if (bundleInput) {
        bundleInput.dataset.variantId = variant.id;
        bundleInput.dataset.price = variant.price;
        bundleInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var bundleVariantTitle = $('[data-bundle-variant-title]', this.root);
      if (bundleVariantTitle) bundleVariantTitle.textContent = variant.options.join(' / ');

      this.showMediaFor(variant);

      if (variant.id && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    showMediaFor(variant) {
      // Gallery filtered by colour: onSelect swaps the group when the colour
      // changes (even for a combination that doesn't exist) and size changes
      // leave the gallery where it is.
      if ($('.product-gallery[data-colour-filter]', this.root)) return;

      if (!variant.featured_media_id) return;
      var slide = $('[data-media-id="' + variant.featured_media_id + '"]', this.root);
      if (!slide) return;
      var index = slide.dataset.gallerySlide;
      var thumb = $('[data-gallery-thumb="' + index + '"]', this.root);
      if (thumb) thumb.click();
    }

    /* Grey out values that cannot combine with what is already chosen. */
    syncAvailability() {
      var selected = this.selectedOptions;
      var variants = this.variants;

      $$('.option-block', this).forEach(function (block) {
        var index = parseInt(block.dataset.optionIndex, 10);

        $$('[data-option-select]', block).forEach(function (btn) {
          var candidate = selected.slice();
          candidate[index] = btn.dataset.optionValue;

          var match = variants.find(function (v) {
            return candidate.every(function (value, i) {
              return i === index || value === undefined || v.options[i] === value;
            }) && v.options[index] === btn.dataset.optionValue;
          });

          var sellable = variants.some(function (v) {
            return v.options[index] === btn.dataset.optionValue && v.available;
          });

          var combinable =
            match &&
            variants.some(function (v) {
              return (
                v.options.every(function (value, i) {
                  return i === index ? value === btn.dataset.optionValue : value === candidate[i];
                }) && v.available
              );
            });

          btn.classList.toggle('is-unavailable', !(combinable || sellable));
        });
      });
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }

  /* ----------------------------------------------------------- product form */

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = $('form', this);
      if (!this.form) return;

      this.button = $('[data-add-button]', this);
      this.label = $('[data-add-label]', this);
      this.errorEl = $('[data-form-error]', this);

      this.form.addEventListener('submit', this.onSubmit.bind(this));

      this.addEventListener('click', function (e) {
        var step = e.target.closest('[data-qty-step]');
        if (!step) return;
        var field = $('[data-qty-field]', this);
        var next = Math.max(1, parseInt(field.value, 10) + parseInt(step.dataset.qtyStep, 10));
        field.value = next;
      });
    }

    onSubmit(e) {
      e.preventDefault();
      if (this.button && this.button.disabled) return;

      var original = this.label ? this.label.textContent : '';
      if (this.button) this.button.disabled = true;
      if (this.errorEl) this.errorEl.hidden = true;

      addToCart(
        new FormData(this.form),
        function () {
          if (this.label) {
            this.label.textContent = (PRONTO.strings && PRONTO.strings.added) || 'Added ✓';
            setTimeout(
              function () {
                this.label.textContent = original;
                if (this.button) this.button.disabled = false;
              }.bind(this),
              1600
            );
          } else if (this.button) {
            this.button.disabled = false;
          }
        }.bind(this),
        function (message) {
          if (this.button) this.button.disabled = false;
          if (this.errorEl) {
            this.errorEl.textContent = message || 'Could not add that to the bag.';
            this.errorEl.hidden = false;
          }
        }.bind(this)
      );
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  /* --------------------------------------------------------- media gallery */

  /*
    Product gallery showing one colour at a time. product-main.liquid tags
    every slide and thumb with the colour indexes it belongs to
    (data-colours="c0 c2") and renders the selected colour's group already
    filtered, so this only runs when the shopper picks another colour.
    A colour with no photos falls back to showing everything.
  */
  function filterGalleryByColour(gallery, options) {
    var values;
    try {
      values = JSON.parse(gallery.dataset.colourValues || '[]');
    } catch (err) {
      return;
    }

    var position = parseInt(gallery.dataset.colourPosition, 10);
    var index = values.indexOf((options || [])[position - 1]);
    if (String(index) === gallery.dataset.colourCurrent) return;

    var token = ' c' + index + ' ';
    var slides = $$('[data-gallery-slide]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var inGroup = function (el) {
      return index >= 0 && (' ' + (el.dataset.colours || '') + ' ').indexOf(token) !== -1;
    };
    var showAll = !slides.some(inGroup);

    var first = null;
    slides.forEach(function (slide) {
      var show = showAll || inGroup(slide);
      slide.hidden = !show;
      if (show) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
      if (show && !first) first = slide;
    });

    var label = $('[data-gallery-thumbs]', gallery);
    var template = (label && label.dataset.label) || '';
    var n = 0;
    thumbs.forEach(function (thumb) {
      var show = showAll || inGroup(thumb);
      thumb.hidden = !show;
      if (show) {
        n += 1;
        thumb.removeAttribute('aria-hidden');
        thumb.removeAttribute('tabindex');
        if (template) thumb.setAttribute('aria-label', template.replace('%n', n));
        var thumbImg = $('img[loading="lazy"]', thumb);
        if (thumbImg) thumbImg.loading = 'eager';
      } else {
        thumb.setAttribute('aria-hidden', 'true');
        thumb.setAttribute('tabindex', '-1');
      }
    });

    gallery.dataset.colourCurrent = String(index);

    if (first) {
      var active = first.dataset.gallerySlide;
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide === first);
      });
      thumbs.forEach(function (thumb) {
        var on = thumb.dataset.galleryThumb === active;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', String(on));
      });
      var img = $('img[loading="lazy"]', first);
      if (img) img.loading = 'eager';
    }

    if (label) {
      label.scrollTop = 0;
      label.scrollLeft = 0;
    }
  }

  function initGallery() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;

      var gallery = thumb.closest('.product-gallery');
      var index = thumb.dataset.galleryThumb;

      $$('[data-gallery-thumb]', gallery).forEach(function (t) {
        var active = t === thumb;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
      });

      $$('[data-gallery-slide]', gallery).forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.gallerySlide === index);
      });
    });
  }

  /* -------------------------------------------------------- bundle offer */

  class BundleOffer extends HTMLElement {
    connectedCallback() {
      this.inputs = $$('[data-bundle-item]', this);
      this.totalEl = $('[data-bundle-total]', this);
      this.wasEl = $('[data-bundle-was]', this);
      this.button = $('[data-bundle-add]', this);

      this.addEventListener('change', this.update.bind(this));
      if (this.button) this.button.addEventListener('click', this.add.bind(this));

      this.update();
    }

    update() {
      var total = 0;
      var was = 0;

      this.inputs.forEach(function (input) {
        var row = input.closest('.bundle__row');
        if (row) row.classList.toggle('is-checked', input.checked);
        if (!input.checked) return;
        total += parseInt(input.dataset.price, 10) || 0;
        was += parseInt(input.dataset.compare, 10) || parseInt(input.dataset.price, 10) || 0;
      });

      if (this.totalEl) this.totalEl.textContent = formatMoney(total);
      if (this.wasEl) {
        this.wasEl.textContent = was > total ? formatMoney(was) : '';
        this.wasEl.hidden = was <= total;
      }
      if (this.button) this.button.disabled = total === 0;
    }

    add() {
      var items = this.inputs
        .filter(function (input) {
          return input.checked;
        })
        .map(function (input) {
          return { id: parseInt(input.dataset.variantId, 10), quantity: 1 };
        });

      if (!items.length) return;

      this.button.disabled = true;

      fetch(routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer' })
      })
        .then(function (r) {
          return r.json();
        })
        .then(
          function (data) {
            return Promise.all([refreshCartDrawer(data.sections), refreshCartCount()]).then(function () {
              if (PRONTO.cartType === 'drawer') openCart();
            });
          }.bind(this)
        )
        .catch(function () {})
        .then(
          function () {
            this.button.disabled = false;
          }.bind(this)
        );
    }
  }

  if (!customElements.get('bundle-offer')) {
    customElements.define('bundle-offer', BundleOffer);
  }

  /* ------------------------------------------------ product recommendations */

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      if ($('.product-grid', this)) return; // server already rendered something

      fetch(this.dataset.url)
        .then(function (r) {
          return r.text();
        })
        .then(
          function (text) {
            var parsed = new DOMParser().parseFromString(text, 'text/html');
            var fresh = parsed.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim()) {
              this.innerHTML = fresh.innerHTML;
              document.dispatchEvent(new CustomEvent('pronto:section:updated'));
            }
          }.bind(this)
        )
        .catch(function () {});
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  /* ------------------------------------------------------- collection facets */

  function initFacets() {
    var sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-facets-toggle]')) {
        var facets = $('[data-facets]');
        if (facets) facets.classList.toggle('is-open');
      }
    });

    var priceForm = $('[data-facet-form]');
    if (priceForm) {
      var priceTimer;
      priceForm.addEventListener('input', function (e) {
        if (e.target.type !== 'number') return;
        clearTimeout(priceTimer);
        priceTimer = setTimeout(function () {
          var params = new URLSearchParams(new FormData(priceForm));
          window.location.search = params.toString();
        }, 800);
      });
    }
  }

  /* --------------------------------------------------------------- load more */

  function initLoadMore() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-load-more]');
      if (!link) return;
      e.preventDefault();

      var target = $(link.dataset.target);
      if (!target) {
        window.location.href = link.href;
        return;
      }

      link.setAttribute('aria-busy', 'true');

      fetch(link.href)
        .then(function (r) {
          return r.text();
        })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var nextGrid = parsed.querySelector(link.dataset.target);
          var nextLink = parsed.querySelector('[data-load-more]');

          if (nextGrid) {
            Array.prototype.forEach.call(nextGrid.children, function (child) {
              target.appendChild(child.cloneNode(true));
            });
          }

          if (nextLink) {
            link.href = nextLink.href;
          } else {
            var wrap = link.closest('.collection-more');
            if (wrap) wrap.remove();
          }

          link.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('pronto:section:updated'));
        })
        .catch(function () {
          window.location.href = link.href;
        });
    });
  }

  /* ------------------------------------------------------- size run expander */

  function initSizeRun() {
    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-size-more]');
      if (!more) return;

      e.preventDefault();
      e.stopPropagation();

      var run = more.closest('[data-size-run]');
      if (!run) return;

      var expanded = run.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded', String(expanded));

      if (expanded) {
        // Collapsing again would hide a size the shopper may have just picked,
        // so the button steps out of the way instead.
        more.hidden = true;
      }
    });
  }

  /* -------------------------------------------------------- shoppable image */

  class ShoppableImage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));

      this.onOutside = function (e) {
        if (!this.contains(e.target)) this.closeAll();
      }.bind(this);
      document.addEventListener('click', this.onOutside);

      this.onKey = function (e) {
        if (e.key === 'Escape') this.closeAll();
      }.bind(this);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutside);
      document.removeEventListener('keydown', this.onKey);
    }

    onClick(e) {
      if (e.target.closest('[data-hotspot-close]')) {
        e.preventDefault();
        this.closeAll();
        return;
      }

      var pin = e.target.closest('[data-hotspot-toggle]');
      if (!pin) return;

      e.preventDefault();
      var open = pin.getAttribute('aria-expanded') === 'true';
      this.closeAll();
      if (!open) this.openPin(pin);
    }

    openPin(pin) {
      var hotspot = pin.closest('.hotspot');
      var card = $('[data-hotspot-card]', hotspot);
      if (!card) return;

      pin.setAttribute('aria-expanded', 'true');
      card.hidden = false;

      // Nudge the card back inside the image if it would hang over an edge.
      hotspot.classList.remove('hotspot--flip-left', 'hotspot--flip-right', 'hotspot--flip-up');

      var bounds = this.getBoundingClientRect();
      var rect = card.getBoundingClientRect();

      if (rect.left < bounds.left) hotspot.classList.add('hotspot--flip-left');
      else if (rect.right > bounds.right) hotspot.classList.add('hotspot--flip-right');

      if (rect.bottom > bounds.bottom) hotspot.classList.add('hotspot--flip-up');
    }

    closeAll() {
      $$('[data-hotspot-toggle]', this).forEach(function (p) {
        p.setAttribute('aria-expanded', 'false');
      });
      $$('[data-hotspot-card]', this).forEach(function (c) {
        c.hidden = true;
      });
    }
  }

  if (!customElements.get('shoppable-image')) {
    customElements.define('shoppable-image', ShoppableImage);
  }

  /* ------------------------------------------------------------ promo pop-up */

  class PromoPopup extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.storageKey || 'pronto:promo';
      this.minGapDays = parseInt(this.dataset.rememberDays, 10) || 0;
      this.perDay = parseInt(this.dataset.perDay, 10) || 0;
      this.perWeek = parseInt(this.dataset.perWeek, 10) || 0;
      this.perMonth = parseInt(this.dataset.perMonth, 10) || 0;

      this.neverDays = parseInt(this.dataset.neverDays, 10) || 0;
      this.inEditor = !!(window.Shopify && window.Shopify.designMode);

      this.bind();

      // Back from a successful sign-up: show the code straight away, and this
      // visitor is done with the pop-up for good.
      if ($('[data-promo-posted]', this)) {
        this.suppressForever();
        this.open();
        // Drop the marker from the address so a refresh does not reopen it
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('customer_posted');
          url.hash = '';
          history.replaceState(null, '', url.toString());
        } catch (err) {
          /* cosmetic only */
        }
        return;
      }

      // A rejected email comes back with an error; reopen so it can be seen.
      if ($('[data-promo-error]', this)) {
        this.open();
        return;
      }

      // In the editor the preview reloads after almost every change, so opening
      // on load made the pop-up reappear constantly. Like Shopify's own themes,
      // it opens only while its section is selected in the sidebar.
      if (this.inEditor) {
        var mine = function (e) {
          return e.detail && e.detail.sectionId === this.dataset.sectionId;
        }.bind(this);
        this.onSelect = function (e) {
          if (mine(e)) this.open();
        }.bind(this);
        this.onDeselect = function (e) {
          if (mine(e)) this.close();
        }.bind(this);
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
        return;
      }

      if (!this.canShow()) return;

      switch (this.dataset.trigger) {
        case 'scroll':
          this.armScroll();
          break;
        case 'exit':
          this.armExit();
          break;
        default:
          this.timer = setTimeout(this.open.bind(this), parseInt(this.dataset.delay, 10) || 0);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
      if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
      if (this.onDeselect) document.removeEventListener('shopify:section:deselect', this.onDeselect);
    }

    /* State shape: { never: bool, until: timestamp, views: [timestamp, ...] }
       Older formats ('never', or an expiry timestamp) are read and upgraded. */
    readState() {
      var raw;
      try {
        raw = localStorage.getItem(this.key);
      } catch (err) {
        return { never: false, views: [] };
      }

      if (!raw) return { never: false, views: [] };
      if (raw === 'never') return { never: true, views: [] };

      try {
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          return { never: !!parsed.never, until: parsed.until || 0, views: parsed.views || [] };
        }
      } catch (err) {
        /* fall through to the legacy timestamp format */
      }

      var until = parseInt(raw, 10);
      if (until) {
        // Legacy "suppressed until" — treat as one view at the point it was set.
        var when = until - this.minGapDays * 86400000;
        return { never: false, views: [when] };
      }

      return { never: false, views: [] };
    }

    writeState(state) {
      try {
        localStorage.setItem(this.key, JSON.stringify(state));
      } catch (err) {
        /* private browsing — caps reset next visit */
      }
    }

    countWithin(views, ms) {
      var cutoff = Date.now() - ms;
      return views.filter(function (t) {
        return t >= cutoff;
      }).length;
    }

    canShow() {
      var state = this.readState();
      if (state.never) return false;
      if (state.until && Date.now() < state.until) return false;

      var views = state.views;

      if (this.perDay && this.countWithin(views, 86400000) >= this.perDay) return false;
      if (this.perWeek && this.countWithin(views, 7 * 86400000) >= this.perWeek) return false;
      if (this.perMonth && this.countWithin(views, 30 * 86400000) >= this.perMonth) return false;

      if (this.minGapDays && views.length) {
        var last = Math.max.apply(null, views);
        if (Date.now() - last < this.minGapDays * 86400000) return false;
      }

      return true;
    }

    recordView() {
      var state = this.readState();
      state.views.push(Date.now());
      // Nothing older than the longest window is ever consulted again.
      var cutoff = Date.now() - 31 * 86400000;
      state.views = state.views.filter(function (t) {
        return t >= cutoff;
      });
      this.writeState(state);
    }

    suppressForever() {
      var state = this.readState();
      state.never = true;
      this.writeState(state);
    }

    suppressForDays(days) {
      var state = this.readState();
      state.until = Date.now() + days * 86400000;
      this.writeState(state);
    }

    armScroll() {
      var depth = parseInt(this.dataset.scroll, 10) || 35;
      this.onScroll = function () {
        var height = document.documentElement.scrollHeight - window.innerHeight;
        if (height <= 0) return;
        if ((window.scrollY / height) * 100 >= depth) this.open();
      }.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    armExit() {
      this.onLeave = function (e) {
        if (e.clientY <= 0 && !e.relatedTarget) this.open();
      }.bind(this);
      document.addEventListener('mouseout', this.onLeave);
      // Phones have no pointer to lose, so fall back to a delay there.
      if (window.matchMedia('(hover: none)').matches) {
        this.timer = setTimeout(this.open.bind(this), 12000);
      }
    }

    bind() {
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-promo-close]')) {
          e.preventDefault();
          this.close();
          return;
        }

        var copy = e.target.closest('[data-promo-copy]');
        if (copy) {
          e.preventDefault();
          this.copy(copy);
        }
      }.bind(this));

      this.onKey = function (e) {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      }.bind(this);
      document.addEventListener('keydown', this.onKey);
    }

    copy(button) {
      var code = button.dataset.code || '';
      var hint = $('[data-promo-copy-hint]', button);
      var original = hint ? hint.textContent : '';

      function done() {
        if (!hint) return;
        hint.textContent = 'Copied';
        setTimeout(function () {
          hint.textContent = original;
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        var tmp = document.createElement('textarea');
        tmp.value = code;
        tmp.setAttribute('readonly', '');
        tmp.style.position = 'absolute';
        tmp.style.left = '-9999px';
        document.body.appendChild(tmp);
        tmp.select();
        try {
          document.execCommand('copy');
        } catch (err) {
          /* nothing to do — the code is on screen to read */
        }
        document.body.removeChild(tmp);
        done();
      }

      announce('Code ' + code + ' copied');
    }

    open() {
      if (this.classList.contains('is-open')) return;
      clearTimeout(this.timer);

      // Stays hidden until this moment, so a suppressed pop-up never becomes a
      // full-viewport element sitting invisibly over the page.
      this.hidden = false;

      if (!this.inEditor) this.recordView();

      // next frame so the transition runs
      requestAnimationFrame(
        function () {
          this.classList.add('is-open');
          this.release = trapFocus(this);
        }.bind(this)
      );
    }

    close() {
      this.classList.remove('is-open');
      if (this.release) this.release();

      var never = $('[data-promo-never]', this);
      if (never && never.checked && !this.inEditor) {
        if (this.neverDays > 0) this.suppressForDays(this.neverDays);
        else this.suppressForever();
      }

      // Put it fully out of the layout once the transition has run.
      setTimeout(
        function () {
          if (!this.classList.contains('is-open')) this.hidden = true;
        }.bind(this),
        320
      );
    }
  }

  if (!customElements.get('promo-popup')) {
    customElements.define('promo-popup', PromoPopup);
  }

  /* --------------------------------------------------------- sticky add to bag */

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      var selector = this.dataset.watch || '[data-add-button]';
      var target = $(selector);

      if (!target || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(
            function (entry) {
              // Show the bar only once the real button has scrolled away.
              this.classList.toggle('is-visible', !entry.isIntersecting);
            }.bind(this)
          );
        }.bind(this),
        { rootMargin: '0px 0px -20% 0px' }
      );

      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('sticky-atc')) {
    customElements.define('sticky-atc', StickyAtc);
  }

  /* ------------------------------------------------------- predictive search */

  // Live results under the search field, from Shopify's predictive search
  // rendering sections/predictive-search. The form underneath still submits to
  // /search, so Enter with nothing highlighted, JS off, or a failed request all
  // fall back to the normal results page.
  var psCount = 0;

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (!this.ready) this.setup();
      if (this.ready) document.addEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      if (!this.ready) return;
      document.removeEventListener('click', this.onDocClick);
      clearTimeout(this.timer);
      this.abort();
    }

    setup() {
      this.input = $('input[type="search"]', this);
      this.form = this.input && this.input.form;
      this.panel = $('[data-ps-panel]', this);
      this.listbox = $('[data-ps-listbox]', this);
      this.loading = $('[data-ps-loading]', this);
      this.status = $('[data-ps-status]', this);
      if (!this.input || !this.panel || !this.listbox || !routes.predictive_search) return;

      this.ready = true;
      this.uid = 'ps' + ++psCount;
      this.minChars = 2;
      this.delay = 250;
      this.cache = {};
      this.term = '';
      this.shownTerm = null;
      this.activeIndex = -1;

      this.onDocClick = this.onDocClick.bind(this);

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));

      // Keep focus in the field while clicking around the panel; links still
      // follow their click.
      this.panel.addEventListener('mousedown', function (e) {
        e.preventDefault();
      });

      this.listbox.addEventListener(
        'mousemove',
        function (e) {
          var option = e.target.closest('[data-ps-item]');
          var index = this.options().indexOf(option);
          if (index !== -1 && index !== this.activeIndex) this.setActive(index, false);
        }.bind(this)
      );

      if (this.form) {
        this.form.addEventListener(
          'submit',
          function () {
            clearTimeout(this.timer);
            this.abort();
            this.close();
          }.bind(this)
        );
      }

      // Coming back with the browser's back button restores the old page state.
      window.addEventListener('pageshow', this.close.bind(this));
    }

    onInput() {
      var term = this.input.value.trim();
      this.term = term;
      clearTimeout(this.timer);

      if (term.length < this.minChars) {
        this.abort();
        this.close();
        return;
      }

      this.timer = setTimeout(this.search.bind(this, term), this.delay);
    }

    onFocus() {
      // Reopen what was there if the field still holds the same words.
      if (this.shownTerm !== null && this.shownTerm === this.input.value.trim()) this.open();
    }

    onFocusOut(e) {
      if (!e.relatedTarget || !this.contains(e.relatedTarget)) this.close();
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.close();
    }

    onKeydown(e) {
      var isOpen = !this.panel.hidden;

      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowUp': {
          if (!isOpen) {
            if (this.shownTerm !== null && this.shownTerm === this.input.value.trim()) {
              e.preventDefault();
              this.open();
            }
            return;
          }
          var options = this.options();
          if (!options.length) return;
          e.preventDefault();
          var step = e.key === 'ArrowDown' ? 1 : -1;
          var next = this.activeIndex + step;
          if (this.activeIndex === -1 && step === -1) next = options.length - 1;
          if (next >= options.length) next = 0;
          if (next < 0) next = options.length - 1;
          this.setActive(next, true);
          break;
        }

        case 'Enter': {
          var active = isOpen && this.options()[this.activeIndex];
          if (active) {
            e.preventDefault();
            active.click();
          }
          // Otherwise the form submits to /search as usual.
          break;
        }

        case 'Escape':
          if (isOpen) {
            // Close just the dropdown, not the mobile menu around it.
            e.preventDefault();
            e.stopPropagation();
            this.close();
          }
          break;
      }
    }

    search(term) {
      if (this.cache[term]) {
        this.abort();
        this.render(term, this.cache[term]);
        return;
      }

      this.abort();
      var controller = 'AbortController' in window ? new AbortController() : null;
      this.controller = controller || {};
      var token = this.controller;
      this.setLoading(true);

      var params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,page,query',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      });

      fetch(routes.predictive_search + '?' + params.toString(), {
        signal: controller ? controller.signal : undefined
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Predictive search ' + res.status);
          return res.text();
        })
        .then(
          function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var results = $('[data-ps-results]', doc);
            if (!results) throw new Error('Predictive search: no results markup');
            var entry = {
              html: results.innerHTML,
              count: parseInt(results.getAttribute('data-ps-count'), 10) || 0
            };
            this.cache[term] = entry;
            // A newer search may have started while this one was in flight.
            if (this.controller === token && this.term === term) this.render(term, entry);
          }.bind(this)
        )
        .catch(
          function (err) {
            if (err && err.name === 'AbortError') return;
            if (this.controller !== token) return;
            // Quietly step aside: Enter still reaches the full search page.
            this.close();
          }.bind(this)
        )
        .then(
          function () {
            if (this.controller === token) {
              this.controller = null;
              this.setLoading(false);
            }
          }.bind(this)
        );
    }

    abort() {
      if (this.controller) {
        if (this.controller.abort) this.controller.abort();
        this.controller = null;
      }
      this.setLoading(false);
    }

    setLoading(isLoading) {
      this.listbox.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      this.classList.toggle('is-loading', isLoading);
      // The text only shows when there's nothing older to look at meanwhile.
      if (this.loading) this.loading.hidden = !isLoading || this.shownTerm !== null;
      if (isLoading) this.open();
    }

    render(term, entry) {
      this.listbox.innerHTML = entry.html;
      this.shownTerm = term;

      // The section's ids are generic; make them unique to this instance.
      $$('[id]', this.listbox).forEach(function (el) {
        el.id = this.uid + '-' + el.id;
      }, this);
      $$('[aria-labelledby]', this.listbox).forEach(function (el) {
        el.setAttribute('aria-labelledby', this.uid + '-' + el.getAttribute('aria-labelledby'));
      }, this);
      this.options().forEach(function (option, i) {
        option.id = this.uid + '-option-' + i;
        option.tabIndex = -1;
      }, this);

      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      if (this.loading) this.loading.hidden = true;
      this.open();

      if (this.status) {
        this.status.textContent =
          entry.count > 0
            ? (this.panel.dataset.statusResults || '').replace('[count]', entry.count)
            : this.panel.dataset.statusNone || '';
      }
    }

    options() {
      return $$('[data-ps-item]', this.listbox);
    }

    setActive(index, scroll) {
      var options = this.options();
      options.forEach(function (option, i) {
        var on = i === index;
        option.classList.toggle('is-active', on);
        option.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.activeIndex = index;
      var active = options[index];
      if (!active) {
        this.input.removeAttribute('aria-activedescendant');
        return;
      }
      this.input.setAttribute('aria-activedescendant', active.id);
      if (scroll) active.scrollIntoView({ block: 'nearest' });
    }

    open() {
      this.panel.hidden = false;
      this.classList.add('is-open');
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.panel.hidden = true;
      this.classList.remove('is-open');
      this.input.setAttribute('aria-expanded', 'false');
      this.setActive(-1, false);
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }

  /* ------------------------------------------------------------------- boot */

  function boot() {
    initReveal();
    initBackToTop();
    initStickyHeader();
    initMobileNav();
    initLocaleForms();
    initAccordions();
    initVideoSound();
    initWishlist();
    initCart();
    initQuickAdd();
    initGallery();
    initFacets();
    initLoadMore();
    initSizeRun();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Product row carousel arrows: move the track by one screenful, and grey out
  // the arrow that has nowhere left to go.
  function syncRowArrows(track) {
    var section = track.closest('section');
    if (!section) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    var pos = Math.abs(track.scrollLeft);
    $$('[data-row-step]', section).forEach(function (btn) {
      btn.disabled = btn.dataset.rowStep === '-1' ? pos <= 2 : pos >= max;
    });
  }

  function initRowCarousels() {
    $$('[data-row-track]').forEach(function (track) {
      if (track.dataset.rowReady) return;
      track.dataset.rowReady = 'true';
      track.addEventListener('scroll', function () { syncRowArrows(track); }, { passive: true });
      syncRowArrows(track);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-row-step]');
    if (!btn) return;
    var section = btn.closest('section');
    var track = section && $('[data-row-track]', section);
    if (!track) return;
    var dir = parseInt(btn.dataset.rowStep, 10) * (document.documentElement.dir === 'rtl' ? -1 : 1);
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  });

  window.addEventListener('resize', function () {
    $$('[data-row-track]').forEach(syncRowArrows);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRowCarousels);
  } else {
    initRowCarousels();
  }
  document.addEventListener('shopify:section:load', initRowCarousels);

  // Re-run the light-weight bits when the theme editor swaps a section.
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initLocaleForms();
  });
})();
